import clsx from 'clsx';
import React from 'react';
import styles from './ReportResultBlock.module.scss';
import { Button } from 'tt-ui-lib/core';
import { Grid } from '@mui/material';
import CalcMenuButton from '../../../CalcMenuButton/CalcMenuButton';
import { CALC_TYPES } from 'utils/calculatorUtils';

const ReportResultBlock = ({ props }) => {
  const { assessment, targetWidth, calcLogo, onViewClick, onMenuClick } = props;

  return (
    <div
      key={assessment.id}
      className={clsx(styles.rowWrapper, targetWidth < 940 && styles.shortFormat)}
    >
      <div className={styles.summary}>
        {calcLogo && <div className={styles.logo}>{calcLogo}</div>}
        <Grid item container alignItems="center" className={styles.draftName}>
          <div
            className={styles.title}
            title={assessment.name}
            style={{ maxWidth: targetWidth > 940 ? 180 : targetWidth - 350 }}
          >
            {assessment.name || '-'}
          </div>
          <div className={styles.container}>
            <span className={styles.data}>Reporting period:</span>
            <span className={styles.dataValue}>
              {assessment.periodReportDate.getFullYear() ?? 'wrong date'}
            </span>
          </div>
        </Grid>
      </div>
      <div className={clsx(styles.dataBlock, styles.buttonCont)}>
        {assessment.type === CALC_TYPES.CUSTOM_REPORT && (
          <Button className={styles.payBtn} onClick={() => onViewClick(assessment.id)}>
            View more
          </Button>
        )}
        <CalcMenuButton params={{ onMenuClick }} />
      </div>
    </div>
  );
};

export default ReportResultBlock;
